export class FirmaElectronicaModel{
    username: string;

    nombreCompleto: string;

    cadenaOriginal: string;

    origen: string;

    selloDigital: string;

    rfcCertificado: string;

    noSerieCertificado: string;

    nombreServidorPublico: string;

    noSerieCertificadoUsuario: string;

    fechaHoraCertificado: string;
}
